import style from 'styled-components'

export const WrapperNewBatch = style.div`
  background-color: #e5e5e5;
  font-family: "Open Sans";
`

export const Title = style.h2`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 24px;
`

export const HR = style.hr`
  margin-top: 1rem;
  margin-bottom: 0;
`

export const WrapperHeader = style.div`
  display: flex;
  justify-content: space-between;
`
